import { atom } from 'jotai';
import { PortableAssetDto } from '../API/types/metadata';

export const KNOWN_TOOLS = atom<PortableAssetDto[]>([]);
